import * as React from "react";
import { cloneElement } from "react";
import { CSSTransition } from "react-transition-group";
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import { ITransitionProps } from "./Transition.types";

const Transition: React.FC<ITransitionProps & Partial<CSSTransitionProps>> = ({
    type,
    timeout = 300,
    ...props
}) => {
    let className = "";
    let transitionProperty = "";

    switch (type) {
        case "fade":
            className = "tmp-fade";
            transitionProperty = "opacity";
            break;
        case "slide":
            transitionProperty = "transform";
            className = "tmp-slide-left";
            switch (props.direction) {
                case "right":
                    className = "tmp-slide-right";
                    break;
                case "top":
                    className = "tmp-slide-top";
                    break;
                case "bottom":
                    className = "tmp-slide-bottom";
                    break;
            }
            break;
    }

    return (
        <CSSTransition
            classNames={className}
            mountOnEnter
            unmountOnExit
            timeout={timeout}
            {...props}
        >
            {(state, childProps) => {
                return cloneElement(props.children as React.ReactElement<any>, {
                    style: {
                        transition: transitionProperty + " " + timeout + "ms",
                        ...childProps.style,
                    },
                    ...childProps,
                });
            }}
        </CSSTransition>
    );
};

export default Transition;
